import React, { Component } from 'react';
import links from 'utils/links';
// import { Link } from 'react-router-dom';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';
/** MaterialUI components */
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CardsSlider from '../../components/card/cardslide';
import EventCardSlider from '../../components/card/EventTypeSlider';
import { storeCityName } from 'utils/';

const styles = theme => ({
  root: {
    flexGrow: 1,
    overflowX: 'hidden',
  },
  media: {
    height: 400,
  },

  about_body: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit + 7,
  },
  readmore: {
    marginTop: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  paramode: {
    marginTop: theme.spacing.unit + 7,
    paddingLeft: '10px',
  },
  inputContainer: {
    backgroundColor: '#eab209',
    paddingBottom: '29px',
  },
  select: {
    borderRadius: '5px',
    backgroundColor: theme.palette.others.bg1,
  },
  margin: {
    width: '100%',
  },
  form_margin: {
    marginTop: theme.spacing.unit + 2,
    marginBottom: theme.spacing.unit + 2,
  },
  event_card: {
    padding: '10px',
    backgroundColor: 'white',
  },
  traveller_delient: {
    padding: '10px',
    backgroundColor: '#eeb700',
    paddingBottom: '60px',
    margin: '0px 0 0px 0',
  },
  sub_label: {
    marginTop: theme.spacing.unit * 2 + 4,
    marginBottom: theme.spacing.unit * 2 + 4,
  },
  native_foods_label: {
    paddingTop: '25px',
    // marginTop: theme.spacing.unit * 2 + 4,
    marginBottom: theme.spacing.unit * 2 + 4,
    paddingLeft: '5px',
  },
  ahara_container: {
    backgroundColor: theme.palette.others.bg1,
    marginTop: '20px',
  },
  native_foods: {
    // paddingTop: '10px',
    paddingBottom: '20px',
    backgroundColor: '#ede9e2',
  },
  card: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '45%',
  },
  content: {
    flex: '1 0 auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
    },
  },
});

class eateryLanding extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentWillMount() {
    storeCityName(this.props.match.params.cityname);
  }
  componentDidMount() {
    this.props.dispatch(actions.getData());
  }
  handleChange = event => {
    storeCityName(event.target.value);
    this.props.history.push(links.eateryLanding(event.target.value));
    this.props.dispatch(actions.getData());
  };
  render() {
    const {
      classes,
      loading,
      history,
      cities,
      mostExplored,
      topRead,
      bestNativeFood,
      topExperiences,
      // localExperiences,
    } = this.props;
    const cityname = this.props.match.params.cityname;
    // console.log(topExperiences);
    if (loading) {
      return <Loader />;
    } else {
      let currentCityName = '';
      let localCuisinesName = '';
      for (var i = 0; i < cities.length; i++) {
        if (cities[i].cityID === cityname) {
          currentCityName = cities[i].cityName;
          if (currentCityName)
            localCuisinesName = cities[i].localCuisines.map(cuisines => {
              return cuisines.name;
            });
        }
      }
      return (
        <div className={classes.root}>
          <Grid container>
            <Grid item xs={12}>
              <CardMedia
                className={classes.media}
                title="eateryLanding"
                image="/img/DSC_1617.JPG"
              />
              <Typography
                component="h3"
                variant="h5"
                className={classes.about_body}
              >
                Eateries
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                From an award-winning fine-dine restaurant in a 7-star hotel in
                Bangalore to a 40-year-old legendary Egg Roll stall on Kolkata's
                Park Street, and everything in between is what you can expect to
                discover in the Eateries section on Talking Street. So long as
                it is something our Pundits recommend, we'll add it to the
                must-try list for that city. That's why you'll find everything -
                quaint cafes, noisy restaurants, self-service outlets,
                personal-butler experiences, street stalls and fine-dine
                establishments. High chances that most that make it to the list
                are decades old.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <br />
              <CardMedia
                className={classes.media}
                title="eateryLanding"
                image="/img/e8.png"
              />
              <Typography
                component="h3"
                variant="h5"
                className={classes.about_body}
              >
                How we choose eateries
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                Community-sourced, Community-verified:
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                No one knows their city better than the locals. And that's why
                the TS Food Pundits. Given their deep expertise and knowledge,
                they are the virtual food guides who point us to the most-loved,
                most-recommended eateries across a city.
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                Key points to note.
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                1. Our Pundits curate only the best, the places they go back to
                again and again. That's about 20% or even less of the total
                options available in most cities. Hence you will find only a
                handful of the selected eateries among the scores out there. No
                disrespect, but if a particular establishment hasn't got
                featured, we probably haven't heard about it from the community
                yet.
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                2. Apart from the taste of the food, some of the other aspects
                we consider before approving an eatery are:
              </Typography>
              <ul>
                <Typography
                  component="h6"
                  variant="body1"
                  className={classes.paramode}
                >
                  <li>
                    Age of the establishment (we like to list eateries only
                    after they have been around for a while)
                  </li>
                </Typography>
              </ul>
              <ul>
                <Typography
                  component="h6"
                  variant="body1"
                  className={classes.paramode}
                >
                  <li>
                    Hygiene (our advice to our Pundits is always to list places
                    they would take their loved ones to)
                  </li>
                </Typography>
              </ul>
              <ul>
                <Typography
                  component="h6"
                  variant="body1"
                  className={classes.paramode}
                >
                  <li>
                    Popularity (only places that serve fresh, tasteful food are
                    popular)
                  </li>
                </Typography>
              </ul>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                3. That's why no ratings. If the Pundits love it, it must be
                really good. So you can choose to eat at any of the
                establishments you find on TS, and the chances of the food being
                outstanding are very high. Of course, perspectives and
                experiences may differ.
              </Typography>
              <Typography
                component="h6"
                variant="body1"
                className={classes.paramode}
              >
                4. Should there be something you'd like to add from your
                experience, do use the Give a Tip / Share a Pic feature to
                provide your perspective. And of course, do add your images too!
              </Typography>
            </Grid>
            <br />
            <Grid item className={classes.ahara_container} xs={12}>
              <div className={classes.inputContainer}>
                <CardContent>
                  <Typography
                    className={classes.form_margin}
                    component="h6"
                    variant="subtitle1"
                  >
                    SHOWING EATERIES IN BANGALORE OR PICK ANOTHER CITY
                  </Typography>
                  <FormControl className={classes.margin}>
                    <Select
                      className={classes.select}
                      value={cityname}
                      onChange={this.handleChange}
                      input={
                        <OutlinedInput
                          labelWidth={0}
                          name="city"
                          id="outlined-city-simple"
                        />
                      }
                    >
                      {cities.map(city => (
                        <MenuItem key={city.id} value={city.name}>
                          {city.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </div>
            </Grid>
          </Grid>
          <div className={classes.event_card}>
            {mostExplored.length > 0 ? (
              <Typography
                variant="subtitle1"
                component="h6"
                className={classes.sub_label}
              >
                {'TS RECOMMENDS'}
              </Typography>
            ) : (
              ''
            )}
            <CardsSlider history={history} cards={mostExplored} />
          </div>

          <div className={classes.event_card}>
            {topRead.length > 0 ? (
              <Typography
                variant="subtitle1"
                component="h6"
                className={classes.native_foods_label}
              >
                {currentCityName.toUpperCase()} : LOCALS RECOMMEND
              </Typography>
            ) : (
              ''
            )}
            <CardsSlider history={history} cards={topRead} />
          </div>
          {topExperiences.length > 0 ? (
            <div className={classes.traveller_delient}>
              {topExperiences.length > 0 ? (
                <Typography variant="subtitle1" className={classes.sub_label}>
                  AHARA EXPERIENCE
                </Typography>
              ) : (
                ''
              )}
              <EventCardSlider history={history} cards={topExperiences} />
            </div>
          ) : (
            ''
          )}

          <div className={classes.event_card}>
            {bestNativeFood.length > 0 ? (
              <Typography variant="subtitle1" className={classes.sub_label}>
                BEST OF {currentCityName.toLocaleUpperCase()} [
                {localCuisinesName
                  .map(cuiName => cuiName.toUpperCase())
                  .join(', ')}
                ] CUISINES
              </Typography>
            ) : (
              ''
            )}
            <CardsSlider history={history} cards={bestNativeFood} />
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(eateryLanding));
